import { MessageSignal, SpecialMessageId } from '../types/chats.enums'

import type { IConversation } from '../types/conversation.types'

const isUnreadCandidateMessage = (message: NonNullable<IConversation['messages']>[number], currentUserId: string) => {
  return message.sender !== currentUserId && message._id !== SpecialMessageId.TYPING && message.content?.signal !== MessageSignal.TYPING
}

export const getConversationUnreadCount = (conversation: IConversation, currentUserId: string = '') => {
  if (typeof conversation.unreadCount === 'number') {
    return conversation.unreadCount
  }

  const messages = conversation.messages || []
  if (!conversation.lastReadAt) {
    return messages.filter(message => isUnreadCandidateMessage(message, currentUserId)).length
  }

  const lastReadAt = new Date(conversation.lastReadAt).getTime()
  if (Number.isNaN(lastReadAt)) {
    return messages.filter(message => isUnreadCandidateMessage(message, currentUserId)).length
  }

  return messages.filter(message => {
    const messageCreatedAt = new Date(message.createdAt).getTime()
    return messageCreatedAt > lastReadAt && isUnreadCandidateMessage(message, currentUserId)
  }).length
}
